import { render, staticRenderFns } from "./customerDetails.vue?vue&type=template&id=0f7e173b&scoped=true"
import script from "./customerDetails.vue?vue&type=script&lang=js"
export * from "./customerDetails.vue?vue&type=script&lang=js"
import style0 from "./customerDetails.vue?vue&type=style&index=0&id=0f7e173b&prod&scoped=true&lang=scss"
import style1 from "./customerDetails.vue?vue&type=style&index=1&id=0f7e173b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e173b",
  null
  
)

export default component.exports